import { ImplementationMissingException } from '@nu-art/ts-common';
export const EHRInstance_TypeLabelMap = {
    epic: 'Epic',
    cerner: 'Cerner',
    deploy: 'Deploy'
};
export const Const_PhysicianLaunchRelativeUrl = `&user-type=physician`;
export const Const_NurseLaunchRelativeUrl = `&user-type=nurse`;
export const createUrlForEhrInstance = (envUrl, instanceId, userTypeSuffix) => {
    if (!envUrl)
        throw new ImplementationMissingException(`Missing envUrl when trying to create a url for ehrInstance.`);
    if (!instanceId)
        throw new ImplementationMissingException(`Missing instanceId when trying to create a url for ehrInstance.`);
    if (!userTypeSuffix)
        throw new ImplementationMissingException(`Missing userTypeSuffix when trying to create a url for ehrInstance.`);
    let url = envUrl;
    if (!url.endsWith('/'))
        url += '/';
    url = `${url}launch-smart?ehr-id=${instanceId}${userTypeSuffix}`;
    return url;
};
//# sourceMappingURL=consts.js.map